// extracted by mini-css-extract-plugin
module.exports = {"drag-area":"ImageView_drag-area__7GxkJ","active":"ImageView_active__2-EVo","icon":"ImageView_icon__1wYyv","drag-area-image":"ImageView_drag-area-image__3jAK6"};